__turbopack_context__.v({
  "auctionEnd": "fvEhxG_auctionEnd",
  "bar": "fvEhxG_bar",
  "countdown": "fvEhxG_countdown",
  "cta": "fvEhxG_cta",
  "debugBadge": "fvEhxG_debugBadge",
  "divider": "fvEhxG_divider",
  "progressFill": "fvEhxG_progressFill",
  "progressTrack": "fvEhxG_progressTrack",
  "title": "fvEhxG_title",
});
